import styled from "styled-components";
import { colors } from "utils";

const AnalyzingTag = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  padding: 2px 8px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  line-height: 20px;
  max-height: 24px;
  background-color: ${colors.blue50};
  border: 1px solid ${colors.blue300};
  color: ${colors.blue800};
`;

export const SessionInProgressTag = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 11px;
  padding: 2px 8px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  max-height: 24px;
  white-space: nowrap;
  background-color: #FEF2F2;
  border: 1px solid #FCA5A5;
  color: #DC2626;
`;

export const AnalyzingSessionTag = () => (
  <AnalyzingTag>Analyzing Session</AnalyzingTag>
);
